import { jsx } from 'react/jsx-runtime';
import { clsx } from '@flex-design-system/ve-presets';
import { Primitive } from '@radix-ui/react-primitive';
import { forwardRef } from 'react';
import { useFileUploadContext } from '../../context.mjs';
import { dropOverlay } from './drop-overlay.vanilla.mjs';

const FileUploadDropOverlay = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = clsx(dropOverlay, classNameFromProps);
  const { dragging } = useFileUploadContext("FileUpload.DropOverlay");
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "file-upload",
      "data-part": "drop-overlay",
      "data-dragging": dragging,
      className,
      ref: forwardedRef,
      ...props
    }
  );
});
FileUploadDropOverlay.displayName = "FileUpload.DropOverlay";

export { FileUploadDropOverlay };
//# sourceMappingURL=DropOverlay.mjs.map
